<button class="full-width info-button"
  mat-flat-button
  (click)="onTrackOrderClick()">
  <div class="button-content">
    <span class="track-order-label">{{ title | transloco }} </span>
    @if (showOrderDescription) {
      <span class="track-order-description">{{ getOrderDescription(order)}}</span>
    }
  </div>
</button>
